// extracted by mini-css-extract-plugin
module.exports = {"zoomableIndicator":"useZoomable_zoomableIndicator__E_XaU","backdrop":"useZoomable_backdrop__wGrGq"};